module.exports = __webpack_public_path__ + "img/home-img-4.9faa7c85.png";